import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { CalendarIconSvg, SuccessTickIconSvg } from "../../../assets/svg";
import { SelectedUserContext } from "../../../context/selecteduser.context";
import { getItinerarybyEnquiryId } from "../../../api/itinerary.api";
import { useLocation, useNavigate } from "react-router-dom";
import { splitDate } from "../../../utils/splitDate";
import CustomButton from "../../CustomButton/CustomButton";
import dayjs from "dayjs";
import "./style.scss";

interface IItinerarySuccessModal {
  quotation?: boolean;
  currentItineraryDetails?: any;
  setStepNumber: Dispatch<SetStateAction<number>>;
  handleClose?: () => void;
}

const ItinerarySuccessModal: React.FC<IItinerarySuccessModal> = ({ setStepNumber, handleClose, quotation = false, currentItineraryDetails }) => {
  const { selectedUser } = useContext(SelectedUserContext);
  const { existingEnquiry } = useContext(SelectedUserContext);
  const [itineraryData, setItineraryData] = useState<any>([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      const data = await getItinerarybyEnquiryId(existingEnquiry?.id);
      if (data?.status === 200 && !quotation) setItineraryData(data?.result?.result);
      else if (data?.status === 200) setItineraryData([{...currentItineraryDetails}]);
    };
    fetchData();
  }, []);

  return (
    <div className="flex flex-col gap-4 pt-1 itinerary-modal-success-wrapper">
      <div className="flex flex-col gap-2 items-center">
        <SuccessTickIconSvg />
        <span className="header-text">Successful</span>
        {quotation ? (
          <span>Quotation Shared for Itinerary</span>
        ) : (
          <span className="mt-1 subheader-text">Itinerary Details & Ship Info Shared to Guest.</span>
        )}
      </div>
      <div className="flex flex-col gap-3 max-h-[338px] overflow-auto">
        {itineraryData?.map((tripData: any, index: number) => {
          return (
            <div key={tripData?.id} className="flex flex-col gap-2">
              {!quotation && <span className="subheader-text">Itinerary {`${index + 1}`.padStart(2, '0')}</span>}
              <div className="details-card flex flex-col gap-1.5 px-3 py-2">
                <span className="transit-text">{tripData?.route || tripData?.label}</span>
                <span className="date-text flex items-center gap-2">
                  <CalendarIconSvg /> {dayjs(splitDate(tripData?.start_time || tripData.startTime)).format("DD MMM YYYY")} -{" "}
                  {dayjs(splitDate(tripData?.end_time || tripData?.endTime)).format("DD MMM YYYY")}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      {quotation && <span className="w-100 text-center mt-4">Do you want to send quotation for other itineraries?</span>}
      {!quotation && <div className="flex gap-2 self-center">
        <CustomButton fillColor={false} onButtonClick={() => navigate("/")}>
          Go to Homepage
        </CustomButton>
        <CustomButton onButtonClick={() => { navigate(`/add-leads/3/${selectedUser?.id}`); setStepNumber(3); }}>Build Quotation</CustomButton>
      </div>}
      {quotation && <div className="flex gap-2 self-center">
        <a href={location.pathname}> 
          <CustomButton>
            Yes
          </CustomButton>
        </a>  
        <CustomButton fillColor={false} onButtonClick={() => navigate("/")}>No</CustomButton>
      </div>}
    </div>
  );
};

export default ItinerarySuccessModal;
